module.exports = __webpack_public_path__ + "static/MapBackground-87e1b489cdaa3d034e748bf73847b576.png";